"use client"

import dynamic from "next/dynamic"

/**
 * Client-only wrapper for the MapLibre GL intervention map.
 *
 * Why a separate file:
 *   `next/dynamic({ ssr: false })` is forbidden inside a Server
 *   Component in Next.js 16, so we can't dynamic-import the map
 *   directly from `app/(frontend)/affutage/page.tsx`. This file is
 *   marked `"use client"`, which makes the `ssr: false` flag legal
 *   and lets the affutage server page import a stable named component
 *   that internally code-splits the ~300 KB MapLibre bundle.
 */
const InterventionMap = dynamic(
  () =>
    import("@/components/sections/intervention-map").then(
      (mod) => mod.InterventionMap,
    ),
  {
    ssr: false,
    loading: () => (
      <div
        aria-label="Carte d'intervention en cours de chargement"
        className="aspect-[16/9] w-full animate-pulse rounded-2xl bg-muted/40"
      />
    ),
  },
)

export function InterventionMapLazy() {
  return <InterventionMap />
}
